<template>
  <div style="width: 100%; height: 100%">

    <div class="centered-child" style="padding-bottom: 16px">
      <div style="width: 100%; max-width: 200px">
      <img src="/static/team.svg" width="100%">
      </div>
    </div>

    <h2>Personalised help.</h2>
    <p>Our experts are going to contact you for a visa appeal personalised procedure.</p>

    <p>
    If you have some questions you can contact us by email <a @click="onClickContact()">contact-visa@getmyvisatofrance.com</a>. 
    </p>


  </div>
</template>


<script>
import ServiceAccess from '../service/ServiceAccess'

export default {

  created: function () {
    global.navigationBarBus.$on('navigation-back', this.prevScreen)
    global.navigationBarBus.$emit('navigation-display-back', true)
    global.navigationBarBus.$emit('display-save', false)

    ServiceAccess.instance.track(this.$route.params.sessionId, 'screen-contact', {path: this.$route.path})
  },
  destroyed: function () {
    global.navigationBarBus.$off('navigation-back', this.prevScreen)
  },
  
  methods: {
    prevScreen: function () {
      this.$router.back()
    },
    onClickContact: function () {
      global.LC_API.open_chat_window()
    }

  }
}
</script>



// WEBPACK FOOTER //
// ScreenWeContactYou.vue?117d0d40